const adaptProjectForm = (formData = {}) => {
  const preparedProductsData = {};
  formData.products_data.forEach((product) => {
    const preparedValue = {
      each_item_deadline: product.each_item_deadline,
      total_count: product.total_count,
      quantity_data: JSON.stringify(product.quantity_data),
    };
    preparedProductsData[product.id] = preparedValue;
  });
  formData.products_data = preparedProductsData;
  formData.user_id = formData.user_id.id;
  return formData;
};

const requestAdapter = {
  adaptProjectForm,
};

export default requestAdapter;



// WEBPACK FOOTER //
// ./src/_shared/api-services/_requestAdapter.js